// 안전보건공단 화학물질정보시스템(MSDS) 검색
// 공공데이터포털 인증키는 더 이상 브라우저에서 다루지 않는다 - 백엔드가 키 관리ㆍCORSㆍ캐싱을
// 대신 처리하고, 프론트는 아래 서버 프록시 엔드포인트만 호출한다. (docs: api-msds-openapi.md)
import HttpRequest from "@/util/HttpRequest";
import { extractErrorMessage } from "./apiErrorUtil";

// 화면의 searchCnd(국문명 0 / CAS No 1 / UN No 2 / KE No 3 / EN No 4) -> 서버 API 의 searchType
const SEARCH_TYPE_BY_SEARCH_CND = {
  0: "name",
  1: "cas",
  2: "un",
  3: "ke",
  4: "en",
};

// 화학물질 목록 검색 (searchCnd: 국문명 0, CAS No 1, UN No 2, KE No 3, EN No 4)
export async function searchChemList({ searchWrd, searchCnd = 0, numOfRows = 20, pageNo = 1 }) {
  try {
    const result = await HttpRequest.get(
      "/api/v1/msds/substances",
      { params: { q: searchWrd, searchType: SEARCH_TYPE_BY_SEARCH_CND[searchCnd] || "name", page: pageNo, perPage: numOfRows } },
      true
    );
    return result.items || [];
  } catch (err) {
    throw new Error(extractErrorMessage(err, "MSDS 정보를 불러오지 못했습니다."));
  }
}

// 유해성ㆍ위험성 상세 조회. 목록 조회 결과의 chemId, lastDate 를 그대로 넘겨야 서버가 캐시 최신도를
// 정확히 판단한다(lastDate 를 안 주면 TTL 로 대체 판단).
export async function getChemHazardDetail(chemId, lastDate) {
  try {
    const result = await HttpRequest.get(
      `/api/v1/msds/substances/${chemId}/hazard`,
      { params: lastDate ? { lastDate } : {} },
      true
    );
    return result;
  } catch (err) {
    throw new Error(extractErrorMessage(err, "MSDS 정보를 불러오지 못했습니다."));
  }
}

// getChemHazardDetail() 응답을 GHSWarningLabel/PopupMSDSSearch 가 쓰는
// { 유해위험문구: [{코드,문구}], 예방조치문구: [{구분,코드,문구}] } 형태로 변환한다
export function extractWarningStatements(hazardDetail) {
  const 유해위험문구 = (hazardDetail.hazardStatements || []).map((h) => ({
    is_checked: false,
    코드: h.code,
    문구: h.text,
  }));

  const 예방조치문구 = [];
  const precautionaryStatements = hazardDetail.precautionaryStatements || {};
  for (const [구분, list] of Object.entries(precautionaryStatements)) {
    for (const p of list) {
      예방조치문구.push({ is_checked: false, 구분, 코드: p.code, 문구: p.text });
    }
  }

  return { 유해위험문구, 예방조치문구 };
}
